// extracted by mini-css-extract-plugin
export default {"flex":"style_flex__Z+Yi1","right":"style_right__rPFqT","left":"style_left__cIIvt","center":"style_center__Zd+eI"};